import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  MenuItem,
  Box,
} from '@mui/material';
import Modal from '../../../components/Modal';
import Form from '../../../components/useForm';
import { Controls } from '../../../components/controls/Controls';
import AppointmentTypeTable from './AppointmentTypeTable';

export default function AppointmentTypeConfigurationModal(props) {
  const {
    isOpen,
    handleClose,
    setting,
    handleSave,
    appointmentTypes,
    selectedPlans,
  } = props;

  const [appointmentPlanPairs, setAppointmentPlanPairs] = useState(
    setting.value ? JSON.parse(setting.value) : [],
  );
  const [selectedAppointmentType, setSelectedAppointmentType] = useState(null);
  const [error, setError] = useState('');

  const handleTypeAddition = () => {
    if (!selectedAppointmentType) {
      setError('Please select appointment type');
      return;
    }
    if (appointmentPlanPairs.find(
      (pair) => pair.id === selectedAppointmentType.typeId.toString(),
    )) {
      setError('Appointment type already exists');
      return;
    }

    setError('');
    setAppointmentPlanPairs(
      [
        ...appointmentPlanPairs,
        {
          id: selectedAppointmentType.typeId.toString(),
          name: selectedAppointmentType.name,
          intakePlanId: '',
        },
      ],
    );
    setSelectedAppointmentType(null);
  };

  const handleSaveChanges = () => {
    handleSave(setting, JSON.stringify(appointmentPlanPairs));
    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Appointment type configuration"
      size="md"
    >
      <Form>
        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
          <Grid item xs={12} sm={8}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Controls.Select
                fullWidth
                name="appointmentType"
                label="Appointment type"
                value={selectedAppointmentType}
                onChange={(event) => {
                  setSelectedAppointmentType(event.target.value);
                  setError('');
                }}
                renderValue={(value) => value.name}
                error={error}
              >
                {appointmentTypes.map((appointmentType) => (
                  <MenuItem key={appointmentType.typeId} value={appointmentType}>
                    {appointmentType.name}
                  </MenuItem>
                ))}
              </Controls.Select>
              <Controls.Button
                text="Add"
                onClick={handleTypeAddition}
                sx={{ minWidth: '100px', height: '56px' }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Controls.Button
              text="Save"
              onClick={handleSaveChanges}
              sx={{ minWidth: '100px', height: '56px' }}
            />
          </Grid>
        </Grid>
        <AppointmentTypeTable
          selectedPlans={selectedPlans}
          appointmentPlanPairs={appointmentPlanPairs}
          setAppointmentPlanPairs={setAppointmentPlanPairs}
        />
      </Form>
    </Modal>
  );
}

AppointmentTypeConfigurationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setting: PropTypes.shape({
    name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  handleSave: PropTypes.func.isRequired,
  appointmentTypes: PropTypes.arrayOf(
    PropTypes.shape({
      typeId: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedPlans: PropTypes.arrayOf(
    PropTypes.shape({
      actionListId: PropTypes.number,
      id: PropTypes.number,
      isIntakePlan: PropTypes.bool,
      languagesToTranslate: PropTypes.arrayOf(PropTypes.string),
      uniqueName: PropTypes.string,
    }),
  ).isRequired,
};
